import { useEffect } from "react";
import { Navigation } from "./navigation";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

export const BillingPage = () => {

    const { state } = useLocation();
    const { plan, billing, currency } = state || {};

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    return (
        <div id="billing-page">
            <Navigation />
            <div className="billing-container">
                <h2 className="billing-title"> Billing Information</h2>
                <p className="billing-subtitle">Manage your subscription and payment details</p>

                <div className="billing-section">
                    <h3>Current Plan</h3>
                    {plan ? (
                        <p>
                            <strong>{plan.name} Plan</strong> –{" "}
                            {plan.price?.[currency]?.[billing] ?? "N/A"}/month ({billing})
                        </p>
                    ) : (
                        <p>No plan selected</p>
                    )}
                    <Link to="/pricing">
                        <button className="billing-button">Change Plan</button>
                    </Link>
                    <button className="billing-button">Pay Now</button>
                </div>

                <div className="billing-section">
                    <h3>Payment Method</h3>
                    <p>Visa ending in 4242</p>
                    <button className="billing-button">Update Payment Method</button>
                </div>

                <div className="billing-section">
                    <h3>Billing History</h3>
                    <ul className="billing-history">
                        <li><span>March 1, 2025</span><span>$50.00</span></li>
                        <li><span>February 1, 2025</span><span>$50.00</span></li>
                        <li><span>January 1, 2025</span><span>$50.00</span></li>
                    </ul>
                </div>

                <div className="billing-section">
                    <button className="billing-button danger">Cancel Subscription</button>
                </div>
            </div>
        </div>
    );
};